import { VigorousSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { DAY_OPTIONS, TIME_OPTIONS, calculateMET } from "./helpers";

export default function Step2Vigorous({ dias, onDiasChange, tiempo, onTiempoChange, errors }) {
  const showTime = dias && dias !== "0";
  const met = calculateMET(8.0, dias, tiempo);
  const isUnsure = tiempo === "unsure";

  return (
    <div>
      <VigorousSVG />
      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        Piensa en actividades <strong>intensas</strong> que te hicieron respirar mucho más fuerte
        de lo normal. Por ejemplo: correr, pesas, funcional, fútbol, spinning, HIIT, crossfit.
      </div>

      <PillSelect
        label="Días de actividad vigorosa (últimos 7 días)"
        options={DAY_OPTIONS}
        value={dias}
        onChange={onDiasChange}
        error={errors?.getError("vigorosaDias")}
        testId="f3-vig-dias"
        columns={4}
      />

      {showTime && (
        <PillSelect
          label="Tiempo promedio por día"
          options={TIME_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
          value={tiempo}
          onChange={onTiempoChange}
          error={errors?.getError("vigorosaTiempo")}
          testId="f3-vig-tiempo"
          columns={1}
        />
      )}

      {showTime && tiempo && (
        <CalculatedBadge
          label="MET vigorosa/semana"
          value={isUnsure ? "—" : met ?? "—"}
          unit={isUnsure ? "" : "MET-min/sem"}
          category={isUnsure ? "No calculable" : null}
          categoryColor={isUnsure ? "#B5A998" : "#F9A01B"}
          testId="badge-met-vigorosa"
        />
      )}
    </div>
  );
}
